import React, { useState, useEffect } from "react";
import ProfilesTable from "./ProfilesTable";
import ProgramAdmin from "../../program/programadmin";
import "./onboardingAdmin.css";

const AdminOnboarding = () => {
    const [activeTab, setActiveTab] = useState("users");
    const [formData, setFormData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    
    useEffect(() => {
        fetchForms();
    }, []);

    const fetchForms = async () => {
        setIsLoading(true);
        try {
            const response = await fetch(
                "https://bymolive-backend-995926394015.us-central1.run.app/api/get-all-forms"
            );
            if (response.ok) {
                const data = await response.json();
                const parsedForms = data.forms.map((form) => ({
                    ...form,
                    createdAt: form.createdAt ? new Date(form.createdAt) : null,
                }));
                const sortedForms = parsedForms.sort((a, b) => b.createdAt - a.createdAt);
                setFormData(sortedForms || []);
            } else {
                console.error("Failed to fetch forms.");
            }
        } catch (err) {
            console.error("Error fetching forms:", err);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="admin-dashboard-container">
            <div className="admin-dashboard-header">
                <div className="admin-dashboard-logo">
                    
                    <h1>ONBOARDING</h1>
                </div>
                <div className="admin-dashboard-nav">
                    <nav className="tab-navigation">
                        <button 
                            className={`tab-button ${activeTab === "users" ? "active" : ""}`}
                            onClick={() => setActiveTab("users")}
                        >
                            <i className="fas fa-users"></i> Users
                        </button>
                        <button 
                            className={`tab-button ${activeTab === "programs" ? "active" : ""}`}
                            onClick={() => setActiveTab("programs")}
                        >
                            <i className="fas fa-star"></i> Programs
                        </button>
                    </nav>
                </div>
            </div>

            <div className="admin-dashboard-content">
                {isLoading ? (
                    <div className="loading-spinner">Loading...</div>
                ) : (
                    <>
                        {activeTab === "users" && (
                            <div className="tab-content">
                                <h2 className="section-title">Manage Users</h2>
                                <ProfilesTable 
                                    formData={formData} 
                                    fetchForms={fetchForms} 
                                />
                            </div>
                        )}
                        
                        {activeTab === "programs" && (
                            <div className="tab-content">
                                <h2 className="section-title">Manage Programs</h2>
                                <ProgramAdmin />
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default AdminOnboarding;
